<div class="admin-access-denied" *ngIf="user && !user.isAdmin">
  <h1>Access Denied</h1>
  <p>You do not have admin permissions to view this page.</p>
</div>

<div class="blocked-users-container" *ngIf="user?.isAdmin">
  <header class="admin-header">
    <h1>Blocked Users</h1>
    <p>View users blocked from submitting requests, unblock them, or block a user manually.</p>
  </header>

  <section class="block-form-section">
    <h2>Block a User</h2>
    <form [formGroup]="blockForm" (ngSubmit)="submitBlock()" class="block-form">
      <mat-form-field appearance="outline" class="key-field">
        <mat-label>GMID or email</mat-label>
        <input matInput formControlName="requestorKey" [maxlength]="keyMaxLength" autocomplete="off" />
        <mat-hint>The user is looked up in the directory and confirmed before blocking.</mat-hint>
        <mat-error *ngIf="blockForm.controls.requestorKey.hasError('required') || blockForm.controls.requestorKey.hasError('pattern')">
          A GMID or email is required.
        </mat-error>
        <mat-error *ngIf="blockForm.controls.requestorKey.hasError('maxlength')">
          Maximum {{ keyMaxLength }} characters.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="reason-field">
        <mat-label>Reason (optional)</mat-label>
        <input matInput formControlName="reason" [maxlength]="reasonMaxLength" placeholder="Blocked by administrator" autocomplete="off" />
        <mat-hint align="end">{{ blockForm.controls.reason.value.length }} / {{ reasonMaxLength }}</mat-hint>
        <mat-error *ngIf="blockForm.controls.reason.hasError('maxlength')">
          Maximum {{ reasonMaxLength }} characters.
        </mat-error>
      </mat-form-field>

      <button type="submit" class="block-button" [disabled]="submitting">
        {{ submitting ? 'Blocking...' : 'Block User' }}
      </button>
    </form>
  </section>

  <section class="block-list-section">
    <div class="list-header">
      <h2>Active Blocks <span class="count" *ngIf="!loading && !loadError">({{ blocks.length }})</span></h2>
      <button type="button" mat-stroked-button (click)="refresh()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>

    <div class="state loading-state" *ngIf="loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading blocked users...</p>
    </div>

    <div class="state error-state" role="alert" *ngIf="!loading && loadError">
      <strong>Failed to load blocked users:</strong> {{ loadError }}
      <button type="button" mat-button (click)="refresh()">Retry</button>
    </div>

    <div class="state empty-state" *ngIf="!loading && !loadError && blocks.length === 0">
      <mat-icon>check_circle</mat-icon>
      <p>No users are currently blocked.</p>
    </div>

    <table class="blocks-table" *ngIf="!loading && !loadError && blocks.length > 0">
      <thead>
        <tr>
          <th>User</th>
          <th>Reason</th>
          <th>Blocked At</th>
          <th>Blocked By</th>
          <th class="actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let block of blocks; trackBy: trackBlock">
          <td>
            <ng-container *ngTemplateOutlet="personCell; context: { $implicit: requestorPerson(block) }"></ng-container>
          </td>
          <td class="reason">{{ block.reason || '—' }}</td>
          <td>{{ block.blocked_at | date: 'medium' }}</td>
          <td>
            <div class="person" *ngIf="isRateLimiter(block.blocked_by); else adminCell">
              <div class="avatar placeholder"><mat-icon>speed</mat-icon></div>
              <div class="identity"><span class="name">Rate limiter</span><span class="email">Automatic</span></div>
            </div>
            <ng-template #adminCell>
              <ng-container *ngTemplateOutlet="personCell; context: { $implicit: blockedByPerson(block.blocked_by) }"></ng-container>
            </ng-template>
          </td>
          <td class="actions-col">
            <button type="button" class="remove-button"
              [disabled]="unblockingKey !== null"
              (click)="confirmUnblock(block)">
              {{ unblockingKey === block.requestor_key ? 'Unblocking...' : 'Unblock' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</div>

<ng-template #personCell let-person>
  <div class="person">
    <img *ngIf="person.photo; else noPhoto" [src]="person.photo" alt="" class="avatar" />
    <ng-template #noPhoto>
      <div class="avatar placeholder"><mat-icon>person</mat-icon></div>
    </ng-template>
    <div class="identity">
      <span class="name">{{ person.name }}</span>
      <span class="gmid" *ngIf="person.gmid">{{ person.gmid }}</span>
      <span class="email" *ngIf="person.email">{{ person.email }}</span>
    </div>
  </div>
</ng-template>
